import type { CustomInputItemType } from '../../type/common.type';

/**
 * 두 아이템 카드가 동일한 상품인지 확인합니다.
 * 1. 상품 ID 비교
 * 2. 커스텀 입력값 비교 (둘 다 없거나, 내용이 같아야 함)
 */
export const isSameItemCard = (
  itemA: { id: string | number; custom_input_list?: CustomInputItemType[] },
  itemB: { id: string | number; custom_input_list?: CustomInputItemType[] },
): boolean => {
  // 1. ID 비교
  if (String(itemA.id) !== String(itemB.id)) {
    return false;
  }

  const inputA = itemA.custom_input_list ?? [];
  const inputB = itemB.custom_input_list ?? [];

  // 2. 둘 다 커스텀 입력이 없는 경우 -> 같은 상품
  if (inputA.length === 0 && inputB.length === 0) {
    return true;
  }

  // 3. 커스텀 입력 내용 비교
  return isEqualRecordsArray(inputA, inputB);
};

const isEqualRecordsArray = (arr1: Record<string, string>[], arr2: Record<string, string>[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  return arr1.every((obj, index) => {
    const other = arr2[index];

    const keys1 = Object.keys(obj);
    const keys2 = Object.keys(other);

    if (keys1.length !== keys2.length) return false;

    return keys1.every((key) => obj[key] === other[key]);
  });
};
